import type { MouseEvent } from 'react';

/**
 * Returns an onClick handler for a Link with pathname + hash.
 * If already on the same pathname, it prevents navigation, updates the URL hash,
 * and smooth-scrolls to the target element. Otherwise lets Link navigate normally.
 */
export function handleHashLinkClick(pathname: string, hash: string) {
  return (e: MouseEvent<HTMLAnchorElement>) => {
    if (typeof window === 'undefined') return;
    if (window.location.pathname !== pathname) return;
    e.preventDefault();
    const id = hash.replace('#', '');
    const url = `${pathname}${hash}`;
    window.history.replaceState(null, '', url);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
}
